// extracted by mini-css-extract-plugin
export var h1 = "Typography-module--h1--6f492";
export var h2 = "Typography-module--h2--88eae";
export var h3 = "Typography-module--h3--0818b";
export var h4 = "Typography-module--h4--85e38";
export var p1 = "Typography-module--p1--3529c";
export var p2 = "Typography-module--p2--cf6e8";
export var p3 = "Typography-module--p3--679dd";
export var trademark = "Typography-module--trademark--5fdaa";
export var weightBold = "Typography-module--weightBold--428ae";
export var weightMedium = "Typography-module--weightMedium--af216";